import { easeCubic } from 'd3-ease';
import { selection } from 'd3-selection';

interface TransitionOptions {
  duration: number;
  delay?: number;
  name?: string;
  ease?: (t: number) => number;
}

declare module 'd3-selection' {
  export interface Selection<
    GElement extends BaseType,
    Datum,
    PElement extends BaseType,
    PDatum,
  > {
    /** This extends the transition method to not perform transitions when duration is zero. Used to avoid interpolation being performed for e.g. screenshots when the duration is zero.
     * @example text.conditionalTransition({ duration: 0 }) // no transition will be applied, the selection is returned
     * @example text.conditionalTransition({ duration: 2000 }) // a transition will be applied as normal
     */
    conditionalTransition(
      this: Selection<GElement, Datum, PElement, PDatum>,
      options: TransitionOptions | ValueFn<GElement, Datum, TransitionOptions>,
    ): this;
    end: (value?: any) => Promise<void>;
  }
}

selection.prototype.conditionalTransition = function ({
  duration,
  delay = 0,
  name,
  ease = easeCubic,
}: TransitionOptions) {
  return duration === 0
    ? this
    : this.transition(name).duration(duration).delay(delay).ease(ease);
};

selection.prototype.end = function (props?: any) {
  return Promise.resolve(props);
};

export * from 'd3-selection';
